import { invalidateAll } from "$app/navigation";
import { writable } from "svelte/store";
import * as Sentry from "@sentry/sveltekit";

export interface UserData {
  email: string;
  firstName: string;
  lastName?: string;
  avatarUrl: string;
}

const { subscribe, set } = writable<UserData | null>(null);

export const userStore = {
  subscribe,
  async logout() {
    set(null);
    await invalidateAll();
  },
  set(userData: UserData) {
    Sentry.setUser({
      email: userData.email,
      username: userData.lastName
        ? userData.firstName + " " + userData.lastName
        : userData.firstName,
    });
    set(userData);
  },
};
